"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _AccordionPanel = _interopRequireDefault(require("../../../panel/AccordionPanel"));

var _InstallationPanel = require("./InstallationPanel");

var _ExternalLink = require("../../../ui-components/ExternalLink");

var InstallationTab = function InstallationTab(_ref) {
  var isInstalled = _ref.isInstalled,
      onSave = _ref.onSave,
      onClickManage = _ref.onClickManage,
      onClickUninstall = _ref.onClickUninstall;
  var installationPanel = (0, _InstallationPanel.getInstallationPanel)({
    isInstalled: isInstalled,
    onSave: onSave,
    onClickManage: onClickManage,
    onClickUninstall: onClickUninstall
  });
  return (0, _preact.h)("div", {
    className: "installation__tab__wrapper intercom-installation__tab"
  }, (0, _preact.h)("div", {
    className: "installation__tab"
  }, (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: 0,
    panels: [installationPanel]
  })), (0, _preact.h)(_ExternalLink.ExternalLink, {
    label: "How to install the Intercom integration step by step",
    url: "https://communities.gainsight.com/integrations-54/how-to-install-the-intercom-x-cc-integration-22056",
    isExternalLinkForToggle: false
  }));
};

var _default = InstallationTab;
exports.default = _default;